import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { formatNumber } from "../../../../_metronic/helpers/utils";

const ApiModalForm = ({
  setOpenAPIModal,
  getUser,
  user,
  setOpenAPIpermissionsModal,
  setPartnerId
}) => {
  const [apiDetails, setApiDetails] = useState({});
  const [limit, setLimit] = useState();
  const [permissions, setPermissions] = useState([
    { id: 1, name: "Partner API V1", value: "partner_api_v1", checked: false },
    { id: 2, name: "Partner API V2", value: "partner_api_v2", checked: false },
    { id: 3, name: "Bookings API", value: "bookings", checked: false },
  ]);
  const [loading, setLoading] = useState(false);

  const cancel = () => {
    setApiDetails({});
    setLimit();
    setOpenAPIModal(false);
  };

  useEffect(() => {
    if (user && user?.partner_id) {
      setLoading(true);
      axios.get(`${process.env.REACT_APP_API_V3_URL}/partner/${user.partner_id}`)
        .then((res) => {
          setApiDetails(res.data);
          const tempPermissions = res.data?.permissions || [];
          setPermissions(permissions.map((p) => {
            return {
              ...p,
              checked: tempPermissions.includes(p.value)
            }
          }))
        }).catch((err) => {
          toast.error(err?.response?.data?.message || 'Could not fetch permissions');
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [user]);

  const enableAPI = () => {
    setLoading(true);
    const selectedPermissions = permissions.filter((p) => p.checked)?.map((p) => p.value);
    axios.post(`${process.env.REACT_APP_API_V3_URL}/partner`, {
      user_id: user.id,
      usage_limit: limit,
      permissions: selectedPermissions,
    })
      .then(() => {
        toast.success("API access have been enabled for this user successfully");
        getUser();
        cancel();
        setLoading(false);
      })
      .catch((err) => {
        if (err && err.response && err.response?.data && err.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Technical Error, Please Try Again");
        }
        setLoading(false);
      });
  }

  const handleTopUp = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_V3_URL}/partner/${user?.partner_id}/topup`, {
        limit
      });
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Error while adding partners API usages');
    }
  }

  const modifyAPI = () => {
    setLoading(true);
    const selectedPermissions = permissions.filter((p) => p.checked)?.map((p) => p.value);
      axios.patch(`${process.env.REACT_APP_API_V3_URL}/partner/${user?.partner_id}/permissions`, { 
      permissions: selectedPermissions 
      })
      .then(() => {
        toast.success("API Access have been modified for this user successfully");
        if (limit) {
          handleTopUp();
        }
        getUser();
        cancel();
      })
      .catch((err) => {
        if (err && err.response && err.response?.data && err.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Technical Error, Please Try Again");
        }
      }).finally(() => {
        setLoading(false);
      });
  }

  const handleDisable = useMemo(() => {
    if (!user?.partner_id) {
      return (!limit || !permissions.some((p) => p.checked) || loading)
    } else {
      return loading
    }

  }, [apiDetails, limit, permissions, user, loading]);

  console.log(handleDisable)

  return (
    <>
      <div
        className="d-flex flex-column scroll-y me-n7 pe-3"
        id="kt_modal_add_user_scroll"
        data-kt-scroll="true"
        data-kt-scroll-activate="{default: false, lg: true}"
        data-kt-scroll-max-height="auto"
        data-kt-scroll-dependencies="#kt_modal_add_user_header"
        data-kt-scroll-wrappers="#kt_modal_add_user_scroll"
        data-kt-scroll-offset="300px"
      >
        {user?.partner_id && apiDetails && 
        <div className="fv-row mb-5">
          <div className='mb-3 fw-bolder fs-4'>Current API Limit:</div>
          <div style={{
            backgroundColor: 'rgb(192, 192, 192)',
            borderRadius: 15,
            position: 'relative',
            height: 20,
            overflow: 'hidden',
          }}>
            <div
              style={{
                width: `${apiDetails?.used / apiDetails?.usage_limit * 100}%`,
                height: '100%',
                backgroundColor: 'rgb(116, 194, 92)',
                borderRadius: 15
              }}
            />
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#fff'
              }}
            >
              {formatNumber(apiDetails?.used)} / {formatNumber(apiDetails?.usage_limit)}
            </div>
          </div>
        </div>
        }
        <div className="fv-row">
          <label className="form-label fs-6 fw-bold">{user?.partner_id ? 'Increase/Decrease API Usage Limit by' : 'API Usage Limit'}</label>
          <input
            className="form-control form-control-solid w-100 "
            placeholder="Enter API Usage Limit"
            value={limit}
            onChange={(e) => {
              const value = e.target.value
              const allowNegativeRegex = /^[+-]?(0|[1-9]\d*)?$/
              const allowPositiveRegex = /^(0|[1-9]\d*)?$/
              if (user?.partner_id) {
                if (allowNegativeRegex.test(value)) {
                  setLimit(value)
                }
              } else {
                if (allowPositiveRegex.test(value)) {
                  setLimit(value)
                }
              }
            }}
          />
        </div>
        <div className="mt-5">
          <label className="form-label fs-6 fw-bold">Select Partners API permissions for the User:</label>
          <div className="mt-2 d-flex flex-column gap-3">
            {
              permissions.map((el, index) => (
                <div className="form-check form-check-custom form-check-solid" key={index}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={el.value}
                    id="flexCheckChecked"
                    checked={el.checked}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setPermissions((prev) =>
                      prev.map((el) => {
                        if (el.value === e.target.value) {
                          return { ...el, checked };
                        }
                        return el;
                      })
                    );
                  }}
                  />
                  <label
                    className="form-check-label"
                    style={{ fontWeight: "700", color: "#3f4254" }}
                  >
                    {el.name}
                  </label>
                </div>
              ))
            }
          </div>
        </div>
      </div>
      <div className="text-center pt-15">
        <button
          type="reset"
          onClick={() => cancel()}
          className="btn btn-light mx-3"
          data-kt-users-modal-action="cancel"
        >
          Discard
        </button>

        <button
          type="submit"
          className="btn"
          data-kt-users-modal-action="submit"
          style={{ background: "#ffa459", color: "#fff" }}
          disabled={handleDisable}
          onClick={user?.partner_id ? modifyAPI : enableAPI}
        >
          <span className="indicator-label">{user?.partner_id ? 'Update' : 'Enable'} API Access</span>
        </button>
      </div>
    </>
  );
};

export { ApiModalForm };
